export const ApplicationUserState = {
    UserIsAuthenticated: 1,
    UserOrgIsLoaded: 2,
    UserHasNoOrganization: 4,
    UserIsLoadingLandingPage: 8,
    UserIsLoadingLandingPageRequireAuth: 12
}
